<template>
    <div class="kontakt">
        <!-- 背景图片和文字 -->
        <div class="bg-section">
            <h2>AVBOKNINGSREGLER:</h2>
            <p>Du kan av- eller omboka din tid fram till 24 timmar innan ditt besök och det måste ske på en vardag. Då hinner vi erbjuda tiden till någon annan.</p>
            <p>Detta gör du genom att meddela oss via telefonsamtal eller SMS på 070-4281756. Vid försenad avbokning eller uteblivande utkrävs full betalning.</p>
        </div>

        <!-- 大标题 -->
        <h1 class="main-title">Kontakt</h1>
        <div class="underline"></div>

        <!-- 表单和卡片区域 -->
        <div class="form-section">
            <!-- 右侧卡片 -->
            <div class="cards">
                <div class="card">
                    <h3>BEHANDLINGAR</h3>
                    <p>Läs mer om Traditionell Kinesisk Medicin behandlingar 
                        <!-- <a href="#">klicka här</a> -->
                    </p>
                </div>
                <!-- 重复两个相同卡片 -->
                <div class="card">
                    <h3>HUR VI KAN HJÄLPA</h3>
                    <p>Lorem ipsum dolor sit amet natoquet vitae justo viverra orci
                        <!-- <a href="#">klicka här</a> -->
                    </p>
                </div>
                <div class="card">
                    <h3>OM OSS</h3>
                    <p>Vi är experter på Kinesisk Medicin
                        <!-- <a href="#">klicka här</a> -->
                    </p>
                </div>
            </div>

            <!-- 左侧表单 -->
            <form class="contact-form">
                <div class="form-group">
                    <label for="name">Namn</label>
                    <input type="text" id="name" required>
                </div>
                <div class="form-group">
                    <label for="phone">Telefonnummer *</label>
                    <input type="tel" id="phone" required>
                </div>
                <div class="form-group">
                    <label for="email">E-post *</label>
                    <input type="email" id="email" required>
                </div>
                <div class="form-group">
                    <label for="message">Meddelande *</label>
                    <textarea id="message" required></textarea>
                </div>
                <button type="submit" class="submit-btn book-btn">SKICKA</button>
            </form>
        </div>

        <!-- BOKA TID 和地图 -->
        <div class="booking-section">
            <button class="book-btn" @click="toLink">BOKA TID</button>
            <router-link to="/full-screen-image">
                <img src="@/assets/kontakt/googleMap.jpg" alt="Google Map" class="map-img">
            </router-link>
        </div>

        <!-- 底部联系信息 -->
        <div class="contact-info">
            <div class="info-text">
                <h2>Kontakt</h2>
                <div class="info-border"></div>
                <p>Möllegränden 10, 25223 Helsingborg</p>
                <p>0046-070428 17 56</p>
                <p>modongmichael@gmail.com</p>
            </div>
            <img src="@/assets/kontakt/adress.jpg" alt="Address" class="address-img">
        </div>
    </div>
</template>

<script>
export default {
    name: "KontaktPage",
    data() {
        return {};
    },
    methods: {
        toLink() {
            window.open('https://yghealthab.simplybook.it/v2/', '_blank');
        }
    },
};
</script>

<style scoped>
.kontakt {
    min-width: 1200px; 
    width: 1200px; 
}

.main-title {
    text-align: left;
    margin-bottom: 10px;
    font-size: 2rem; /* 添加字体大小 */
    font-weight: bold; /* 添加字体加粗 */
}

.info-text h2 {
    text-align: left;
    font-size: 2rem; /* 与main-title一致 */
    font-weight: bold; /* 与main-title一致 */
    margin-bottom: 10px; /* 添加与main-title一致的间距 */
}

.underline {
    border-bottom: 2px solid #000;
    /* width: 100px; */
    margin-bottom: 20px;
}

.form-section {
    display: flex;
    gap: 40px;
    margin-bottom: 40px;
    align-items: stretch; /* 修改为stretch使高度一致 */
}

.cards {
    width: 30%;
    order: 2;
    display: flex;
    flex-direction: column;
}

.card {
    background: #f5f5f5;
    padding: 20px;
    margin-bottom: 20px;
    border-radius: 8px;
    flex: 1; /* 使卡片均匀分布高度 */
}

.contact-form {
    width: 70%;
    order: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between; /* 使表单内容均匀分布 */
}

.form-group {
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
}

.form-group label {
    text-align: left;
    margin-bottom: 8px;
    font-weight: bold;
}

.form-group input,
.form-group textarea {
    width: 100%;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
}

.submit-btn {
    background: #007bff;
    color: white;
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

.booking-section {
    text-align: center;
    margin-bottom: 40px;
}

.book-btn {
    background: #28a745;
    color: white;
    padding: 15px 30px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    margin-bottom: 20px;
}

.map-img {
    width: 100%;
    max-height: 400px;
    object-fit: cover;
}

.contact-info {
    display: flex;
    gap: 40px;
    margin-bottom: 40px;
}

.info-text {
    width: 50%;
}

.info-text h2 {
    text-align: left; /* 确保标题左对齐 */
}

.info-border {
    border-bottom: 2px solid #000;
    width: 100%; /* 将宽度改为100% */
    margin: 10px 0 20px;
}

.address-img {
    width: 50%;
    height: auto;
    object-fit: cover;
}

.bg-section {
    background-image: url('@/assets/bg.png');
    background-size: cover;
    background-position: center;
    padding: 40px;
    margin-bottom: 40px;
    color: black; /* 将字体颜色改为黑色 */
}

.bg-section h2 {
    font-size: 1.5rem;
    margin-bottom: 20px;
}

.bg-section p {
    margin-bottom: 10px;
    line-height: 1.6;
}
</style>
